import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import DocumentTypeMetadataModalPage from '../../../containers/masters/Metadata/MetadataModalPage'
import DocumentTypeMetadataListModalPage from '../../../containers/masters/Metadata/MetadataListModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { typeFields as metadataType } from '../../../constants/dossier/common/typeFields'
import { getComboTranslatedFromEnum } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class MetadataMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      documentTypeId: -1,
      filter: {
        entityTypeId: null,
        text: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchDocumentTypeCombo()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changedValue (value) {
    this.setState({ documentTypeId: value })
    this.props.actions.fetchDocumentTypeMetadataList({ ...this.props.filter, ...this.state.filter, page: 1, documentTypeId: value ?? -1 })
  }

  render () {
    const {
      t, pagesCount, documentTypeMetadataListCount, filter, documentTypeMetadataList, languageSelected,
      combos: { documentTypes },
      filter: { page },
      actions: { openDocumentTypeMetadataModal, fetchDocumentTypeMetadataList, deleteDocumentTypeMetadata, openMetadataListModal }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'documentTypeMetadataMasterPage' })
    const tKey = 'MASTERS.METADATA_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const editListTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT_METADATA_LIST`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    let metadatoTypes = getComboTranslatedFromEnum(t, tKey, metadataType)
    return (
      <div id='metadataMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              disabled={this.props.invalid}
              className="_Btn new"
              onClick={() => openDocumentTypeMetadataModal(null, this.state.documentTypeId)}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                name="documentType"
                controlLabel={t(`${tKey}DOCUMENT_TYPES`)}
                placeholder={t(`${tKey}DOCUMENT_TYPES`)}
                valueKey="id"
                labelKey="value"
                component={InputSelect}
                colSm={6}
                options={documentTypes}
                onChange={(val) => this.changedValue(val)}
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(documentTypeMetadataList.length !== 0 && this.props.invalid === false) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th>
                        {t(`${tKey}METADATO_TYPE`)}
                      </th>
                      <th>
                        {t(`${tKey}CODE`)}
                      </th>
                      <th>
                        {t(`${tKey}NAME`)}
                      </th>
                      <th>
                        {t(`${tKey}DESCRIPTION`)}
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {documentTypeMetadataList && documentTypeMetadataList.map((documentTypeMetadata, idx) => {
                      return (
                        <tr key={idx} className={documentTypeMetadata.isDeleted ? 'is-deleted' : ''}>
                          <td>{metadatoTypes.find(x => x.id === documentTypeMetadata.metadatoType)?.value || ''}</td>
                          <td>{documentTypeMetadata.code}</td>
                          <td>{documentTypeMetadata.metadatoLocales.find(x => x.languageId === languageSelected)?.name || ''}</td>
                          <td>{documentTypeMetadata.metadatoLocales.find(x => x.languageId === languageSelected)?.description || ''}</td>
                          <td className='actions'>
                            {!documentTypeMetadata.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openDocumentTypeMetadataModal(documentTypeMetadata, this.state.documentTypeId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteDocumentTypeMetadata(documentTypeMetadata.metadatoId, this.state.documentTypeId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                                {documentTypeMetadata.metadatoType === metadataType.list && (
                                  <OverlayTrigger placement="left" overlay={editListTooltip}>
                                    <a className='_Btn accent stk o-icn ' onClick={() => openMetadataListModal(documentTypeMetadata)}>
                                      <i className='iDocIcon-list-check-formalities' />
                                    </a>
                                  </OverlayTrigger>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>)
                    })
                    }

                  </tbody>
                </Table>
              }
              {(documentTypeMetadataList === null || documentTypeMetadataList === undefined || documentTypeMetadataList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={documentTypeMetadataListCount}
                    onSelectAction={(value) => fetchDocumentTypeMetadataList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <DocumentTypeMetadataModalPage/>
        <DocumentTypeMetadataListModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentTypeMetadata',
  validate: (values, props) => {
    let error = {}

    const tKey = 'MASTERS.METADATA_MASTERS.VALIDATION.'
    if (!values.documentType) {
      error.documentType = props.t(`${tKey}DOCUMENTS_TYPES`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(MetadataMaster)
